module.exports = __webpack_public_path__ + "img/AH-TRADITIONAL-PROCESSING.548cfa23.jpg";